import { TypeAheadInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { list } from '../../../../../common/classes/request-builder';
import { SectorModel } from 'src/app/models/form-common/sector.model';

export class SectoresListsDefinition {
  distanciasGoteros: TypeAheadInterface<string> =  list(
      ['...', null],
      '25cm',
      '30cm',
      '50cm',
      '95cm',
      '100cm'
  );
     
  fincas: TypeAheadInterface<SectorModel> = {
      selected: null,
      filtered: [{label: '...', value: null}],
      values: []
  };
 
  jardines: TypeAheadInterface<SectorModel> = list(['...', null]); 
}